import * as React from "react";
import { Unsubscribe } from "redux";
import { SpinnerLoader } from "scuid-x";
import { DocCapture } from "../components/doc-capture/DocCapture";
import { DocType } from "../constants/DocType";
import { DcStore } from "../stores/DcStore";
import "./Upload.css";

export interface UploadProps {
  appId?: string;
  coBorrower: string | null;
  debug: boolean;
  uuid?: string;
}

export interface UploadState {
  documents?: DocType[];
  store: DcStore;
  enableLocalDecode?: boolean;
}

export class Upload extends React.Component<UploadProps, UploadState> {
  private unsubscribe: Unsubscribe;

  constructor(props: UploadProps) {
    super(props);
    const store = new DcStore();
    this.unsubscribe = store.subscribe(() => this.onStoreChange());
    this.state = {
      documents: store.getState().documents,
      store,
      enableLocalDecode: null,
    };
  }

  public render() {
    const documents = this.state.documents;

    if (!documents || documents.length === 0) {
      return <SpinnerLoader isFullPage={true}/>;
    }

    const enableLocalDecode = this.state.enableLocalDecode;

    // We need this flag before we initialize the video
    if (enableLocalDecode === null || enableLocalDecode === undefined) {
      return <SpinnerLoader isFullPage={true}/>;
    }

    return (
      <div className="UploadScreen">
        <DocCapture
          appId={this.props.appId}
          coBorrower={this.props.coBorrower}
          debug={this.props.debug}
          documents={documents}
          uuid={this.props.uuid}
          enableLocalDecode={enableLocalDecode}
        />
      </div>
    );
  }

  public componentDidMount() {
    this.state.store.apiActions.getReqDocs(this.props.uuid, this.props.appId,
        this.props.coBorrower, false, null, true); // default to DL for in-house doc cap
    this.state.store.apiActions.getEnableLocalDecode(this.props.uuid, this.props.appId);
  }

  public componentWillUnmount() {
    this.unsubscribe();
  }

  private onStoreChange() {
    const nextState = this.state.store.getState();
    if (this.state.documents !== nextState.documents) {
      this.setState({
        documents: nextState.documents,
      });
    }
    if (this.state.enableLocalDecode !== nextState.enableLocalDecode) {
      this.setState({
        enableLocalDecode: nextState.enableLocalDecode,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/screens/Upload.tsx